import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SurveyQuestion from './SurveyQuestion';
import SubmitButton from './SubmitButton';
import EmbeddedSubmitButton from './EmbeddedSubmitButton';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import createReducer from './reducer';
import { createSubmit } from './actions';
import { t } from '../../../utils/translate';
import persistState from './persistState';
import restoreState from './restoreState';

export default class ResponseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitted: false,
    };
    const persistedState = restoreState(this.props.page.id);
    this.reducer = createReducer(this.props, persistedState);
    this.store = createStore(
      this.reducer,
      undefined,
      compose(
        applyMiddleware(persistState(this.props.page.id)),
        window.devToolsExtension ? window.devToolsExtension() : f => f
      )
    );
  }

  componentDidMount() {
    setTimeout(this.preloadRenderers, 2000);
    window.addEventListener('message', this.handleIframeMessage);
  }

  preloadRenderers() {
    // These are all copy/pasted from async renderers in the components/survey directory
    import(/* webpackChunkName: "TextareaWithUploader" */ '../../common/uploader/TextareaWithUploader');
    import(/* webpackChunkName: "PureHeatMap" */ '../heatmap/PureHeatMap');
    import(/* webpackChunkName: "DateTimeQWidget" */ '../inputs/DateTimeWidget');
    import(/* webpackChunkName: "MultiPartFields" */ '../multipart/MultiPartFields');
    import(/* webpackChunkName: "MultiPartFields" */ '../timed/PureTimed');
  }

  onSubmit(e) {
    this.store.dispatch(createSubmit());
    const state = this.store.getState();
    const { questions, isValid } = getResponseFormValidationState(state);

    if (isValid && !this.state.isSubmitted) {
      this.setState({
        isSubmitted: true,
      });
      window.sessionStorage && window.sessionStorage.clear();
      return true;
    } else {
      e.preventDefault();
      questions[0] && this.focusFirstQuestionError(questions[0]);
    }
  }

  focusFirstQuestionError({ fieldValids, id }) {
    const firstQuestionId = `#question_${id}`;
    const inputs = document.querySelectorAll(
      `${firstQuestionId} input:not([type=hidden]), ${firstQuestionId} textarea, ${firstQuestionId} button`
    );
    const firstInvalid =
      fieldValids && fieldValids.indexOf(false) > -1
        ? fieldValids.indexOf(false)
        : 0;
    inputs[firstInvalid] && inputs[firstInvalid].focus();
  }

  handleIframeMessage = (event) => {
    if (event.data === 'surveyFinished') {
      this.responseForm.submit()
    }
  };

  render() {
    const {
      authenticityToken,
      questions,
      page,
      submitUrl,
      survey,
      token,
      requiredIndicator
    } = this.props;
    const { isSubmitted } = this.state;
    const sorted = questions.sort((a, b) => a.position - b.position);
    const qs = sorted;

    return (
      <Provider store={this.store}>
        <form
          action={submitUrl}
          className="survey_form mb0"
          method="post"
          ref={ref => this.responseForm = ref}
          onSubmit={this.onSubmit.bind(this)}
        >
          <div style={{ display: 'none' }}>
            <input type="hidden" name="utf8" value="✓" />
            <input
              type="hidden"
              name="authenticity_token"
              value={authenticityToken}
            />
            <input type="hidden" name="page_id" value={page.id} />
            <input type="hidden" name="token_id" value={token.id} />
            <input
              type="hidden"
              name="first_access"
              value={token.first_access || new Date().toISOString()}
            />
          </div>
          <ul className="unstyled srv mb0">
            {qs.length ? (
              qs.map(question => (
                <SurveyQuestion
                  {...question}
                  {...this.props}
                  token={this.props.token}
                  environment={this.props.environment}
                  subdomain={this.props.subdomain}
                  key={question.name}
                  requiredIndicator={requiredIndicator}
                   />
              ))
            ) : (
              <li
                style={{
                  fontSize: '1.5em',
                  padding: '6em 2em',
                }}
              >
                <p>{t('no_questions_available')}</p>
                <p>
                  <small>{t('no_questions_details')}</small>
                </p>
              </li>
            )}
            {this.props.questions[0]._type !== "Survey::EmbeddedDecipher" ?
              <SubmitButton id={survey.id} isBusy={isSubmitted} />
              :
              null
            }
          </ul>
        </form>
      </Provider>
    );
  }
}

ResponseForm.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  questions: PropTypes.array,
  page: PropTypes.object,
  submitUrl: PropTypes.string.isRequired,
  survey: PropTypes.object.isRequired,
  token: PropTypes.object.isRequired,
};

ResponseForm.defaultProps = {
  questions: [],
};

const getResponseFormValidationState = state => {
  const questionKeys = Object.keys(state).filter(key => key.match(/question_/));
  const invalidQuestions = questionKeys
    .filter(key => state[key] && !state[key].isValid)
    .map(key => ({
      id: state[key].id,
      errorMessages: state[key].errorMessages,
      fieldValids: state[key].fieldValids,
      text: state[key].text,
    }));
  const isValid = !invalidQuestions.length;
  return {
    questions: invalidQuestions,
    isValid,
  };
};
